import { theme } from '../../../../ThemeContext/ThemeObject';
import { closeIcon } from '../../../shared/styleClasses';

export const classes = {
  buttonRedLight: {
    color: '#E37D7A',
    fontFamily: 'Source Sans Pro',
    textTransform: 'capitalize',
    padding: '8px 18px',
    fontWeight: 'bold',
    fontSize: '15px',
    textDecoration: 'underline',
    backgroundColor: '#ffffff',
    '&:hover': {
      color: '#d74742',
      backgroundColor: '#ffffff',
    },
  },
  revertloadButton: {
    fontFamily: 'Source Sans Pro',
    fontSize: '15px',
    fontWeight: 'bold',
    textTransform: 'none',
    color: '#FFFFFF',
    backgroundColor: '#5BC4BF',
    borderRadius: '6px',
    boxShadow: 'none',
    padding: '8px 18px',
    '&:hover': {
      backgroundColor: '#4da8a4',
      boxShadow: 'none'
    }
  },
  subTitle: {
    fontFamily: 'Source Sans Pro',
    fontSize: '15px',
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    display: 'flex',
    flexDirection: 'column',
    marginTop: '20px'
  },
  noEntitys: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    fontFamily: 'Source Sans Pro, sans-serif',
    color: '#DDDDDD',
    fontSize: '18px',
    fontWeight: 'bold',
    margin: '32px 0px'
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    padding: '60px',
    maxWidth: '800px',
    width: '90%',
    height: '95%',
    maxHeight: '500px',
    borderRadius: '6px',
    dropShadow: '0px 2px 14px #305A6F29',
    position: 'absolute',
    background: '#FFFFFF',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  },
  modalTitle: {
    fontFamily: 'Source Sans Pro',
    fontSize: '30px',
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    display: 'flex',
    flexDirection: 'column'
  },
  modalFormLine: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    columnGap: '50px',
    rowGap: '26px',
    alignItems: 'center',
    marginBottom: '20px',
    width: '100%'
  },
  modalActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 'auto',
    width: '100%',
    columnGap: '16px',
    '& a': {
      '&:hover': {
        textDecoration: 'none'
      }
    }
  },
  closeIcon
}
